/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ConsentEntity,
    ConsentEntityFromJSON,
    ConsentEntityFromJSONTyped,
    ConsentEntityToJSON,
} from './ConsentEntity';

/**
 * 
 * @export
 * @interface CardTypeConsent
 */
export interface CardTypeConsent {
    /**
     * 
     * @type {string}
     * @memberof CardTypeConsent
     */
    exportRestriction?: string;
    /**
     * 
     * @type {string}
     * @memberof CardTypeConsent
     */
    sendPostToCarePrincipal?: string;
    /**
     * 
     * @type {string}
     * @memberof CardTypeConsent
     */
    recurringCard?: string;
    /**
     * 
     * @type {string}
     * @memberof CardTypeConsent
     */
    cardTypeId?: string;
    /**
     * 
     * @type {Array<ConsentEntity>}
     * @memberof CardTypeConsent
     */
    consents?: Array<ConsentEntity>;
}

export function CardTypeConsentFromJSON(json: any): CardTypeConsent {
    return CardTypeConsentFromJSONTyped(json, false);
}

export function CardTypeConsentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardTypeConsent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exportRestriction': !exists(json, 'exportRestriction') ? undefined : json['exportRestriction'],
        'sendPostToCarePrincipal': !exists(json, 'sendPostToCarePrincipal') ? undefined : json['sendPostToCarePrincipal'],
        'recurringCard': !exists(json, 'recurringCard') ? undefined : json['recurringCard'],
        'cardTypeId': !exists(json, 'cardTypeId') ? undefined : json['cardTypeId'],
        'consents': !exists(json, 'consents') ? undefined : ((json['consents'] as Array<any>).map(ConsentEntityFromJSON)),
    };
}

export function CardTypeConsentToJSON(value?: CardTypeConsent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exportRestriction': value.exportRestriction,
        'sendPostToCarePrincipal': value.sendPostToCarePrincipal,
        'recurringCard': value.recurringCard,
        'cardTypeId': value.cardTypeId,
        'consents': value.consents === undefined ? undefined : ((value.consents as Array<any>).map(ConsentEntityToJSON)),
    };
}

